// extracted by mini-css-extract-plugin
export default {"content":"Home_content__iQaRh","hexCard":"Home_hexCard__TfQ1E","cardContent":"Home_cardContent__POvFJ","hexIcon":"Home_hexIcon__+dyJN"};